<template>
  <router-link :to="`/blog/${data.id}/${slugGenerator(data.title)}`">
    <div class="card card__vertical" data-aos="fade-in">
      <div class="card__img">
        <img :src="data.image" alt="company image" />
      </div>

      <h3 class="card__title">{{ data.title }}</h3>

      <div class="card__desc">
        <p class="card__address">
          {{ showWith3Dot(data.short_description,20) }}
        </p>
      </div>

      <div class="blogDetail">
        <p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 15 15"
          >
            <path
              id="Icon_awesome-clock"
              data-name="Icon awesome-clock"
              d="M8.063.563a7.5,7.5,0,1,0,7.5,7.5A7.5,7.5,0,0,0,8.063.563ZM9.789,11.15,7.122,9.212a.365.365,0,0,1-.148-.293V3.829a.364.364,0,0,1,.363-.363H8.788a.364.364,0,0,1,.363.363V7.993l1.92,1.4a.363.363,0,0,1,.079.508L10.3,11.072A.365.365,0,0,1,9.789,11.15Z"
              transform="translate(-0.563 -0.563)"
              fill="#5f5e5e"
            />
          </svg>
          {{$cookie.get("language")=='en' ? new Date(data.created_at).toLocaleDateString("en"): new Date(data.created_at).toLocaleDateString("fa") }}
        </p>
        <p v-if="$root.globalData" class="authorNameBox">
          {{
            $root.globalData.keys.author_text
          }}
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
import CardImg from "../../assets/images/factory2.jpg";
import Callicon from "../svgs/Callicon.vue";
import LocationIcon from "../svgs/LocationIcon.vue";
import Callicon1 from "../svgs/Callicon.vue";

export default {
  components: {
    Callicon,
    LocationIcon,
    Callicon1
  },
  methods: {
     showWith3Dot(string, number) {
      let arrayString = string.split(" ");
      let NewArrayString = " ";
      for (let i = 0; i < number; i++) {
        NewArrayString = NewArrayString + arrayString[i] + " ";
      }
      if (arrayString.length > number) {
        return NewArrayString + "...";
      } else {
        return string;
      }
    },
    slugGenerator(name) {
      if (name == null) return name;
      let result = " ";
      result = name.replace(/ /g, "-");
      return result;
    }
  },
  data() {
    return {
      cards: [
        {
          cardCount: 10,
          cardimg: CardImg,
          cardtitle: "لبنیات کاله",
          cardadress:
            " تهران، خیابان جمهوری، خیابان ۱۲ فروردین نبش تقاطع خیابان آذربایجان، پلاک ۱۳۶ ",
          cardtel: "۰۲۱-۶۶۴۵۴۵۱۱ , ۰۲۱-۶۱۱۲۳۶۴",
          cardlink: "مشاهده شرکت"
        }
      ]
    };
  },
  props: {
    data: Object
  }
};
</script>

<style scoped>
.card {
  min-width: 300px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  text-align: right;
  position: relative;
  margin-bottom: 10px;
  transform: scale(0.9);
}

.card__companylogo {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #fff;
  position: absolute;
  left: 10px;
  top: 150px;
  box-shadow: 0 10px 10px #ddd;

  display: flex;
  justify-content: center;
  align-items: center;
}

.card__img img {
  width: 100%;
  height: 200px;

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.card__companylogo img {
  width: 80%;
}
.card__title {
  padding: 10px 1rem;
}
.card__desc {
}
.card__address,
.card__tel {
  font-size: 14px;
  color: #666;
  padding: 10px;
  display: flex;
    height: max-content;
}
.card__address {
height: 100px !important;
}
.card__tel {
  font-size: 13px;
}

.card__btn {
  width: 100%;
  text-align: center;
  margin: 1rem 0;
}

.card_link {
  padding: 7px;
  width: 70%;
  border-radius: 5px;
  border: 2px solid #0d6efd;
  background-color: #0d6efd;
  color: #fff;
  cursor: pointer;
  transition: ease all 0.3s;
}

.card_link:hover {
  box-shadow: 0 0 10px #0d6efd;
}
.authorNameBox{
  direction: rtl;
}
h3.card__title {
    color: black;
}
</style>
<style>
.ltrStyle .authorNameBox{
  direction: ltr ;
}
</style>